// 2026-10-16 — chat: "refresh time for Live orders? should be reduced to 5 or
// 10 seconds whenever any Live trade?". Live Orders screens poll every 10 s
// while any row is OPEN, 30 s otherwise, and skip ticks while the browser tab
// is hidden. Display only — exits run server-side (Sniper/CB every 15 s), so
// polling faster than 10 s would mostly redraw the same numbers.
import { useEffect, useRef } from "react";

export const LIVE_POLL_FAST_MS = 10000;
export const LIVE_POLL_SLOW_MS = 30000;

export const hasOpenRow = (rows) =>
  Array.isArray(rows) &&
  rows.some((r) => String(r?.status || "").toUpperCase() === "OPEN");

// Calls `fn` on mount, then every 10 s when `fast` is true, else every 30 s.
// Ticks are skipped while the tab is hidden; returning to the tab refreshes at once.
export const useLivePoll = (fn, fast, deps = []) => {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    ref.current();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  useEffect(() => {
    const ms = fast ? LIVE_POLL_FAST_MS : LIVE_POLL_SLOW_MS;
    const id = setInterval(() => {
      if (typeof document !== "undefined" && document.hidden) return;
      ref.current();
    }, ms);
    const onVis = () => { if (!document.hidden) ref.current(); };
    document.addEventListener("visibilitychange", onVis);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [fast]);
};
